import React from 'react';

import {GameCenterWidgetProps} from "../models/game-center-widget.props";
import {Compose, ComposeSettings} from "../../../core/components/composers/compose";
import {GameCenterWidgetController} from "../game-center-widget.controller";
import {GameCenterWidgetHeader} from "./game-center-widget.header";
import {ACTION_TYPES, AD_DISPLAYS} from "../../../core/consts";
import {GameCenterWidgetContent} from "./game-center-widget.content";
import {Popup} from "../../../core/components/misc/dialog/popup";
import styles from "../styles/game-center-widget.module.scss";
import classNames from "classnames";
import {LivePenaltiesModule} from "../../../modules/live-penalties-module/components/live-penalties-module";
import {ExternalAd} from "../../../core/components/ad/external-ad/external-ad";
import {MinuteMediaAdContainer} from "../../../core/components/ad/minute-media-player/minute-media.ad-container";
import {DBA} from "../../../core/app/consts";
import {EXTERNAL_AD_CONFIG} from "../../../apps/website/consts/external-ad-config";

export const GameCenterWidget = ({controller, matchupId, gameId, location, scrollToTop}: GameCenterWidgetProps) => {
  const baseProps = {
    controller,
    matchupId,
    gameId,
    location,
    scrollToTop: () => scrollToTop(),
    onTabChange: (index) => {
      controller.action(ACTION_TYPES.tabChange, {index});

      return false
    }
  };
  const {state, device: {isSmallView}} = controller;

  React.useEffect(() => {
    if (scrollToTop) {
      scrollToTop();
    }
  }, [gameId, matchupId]);

  const {
    shouldShowLivePenaltiesPopup,
    livePenaltiesAthletes,
    livePenaltiesCompetitorNum,
    userCountryId,
  } = state;

  const onClosePopup = () => controller.action(ACTION_TYPES.onLivePenaltiesPopupClick, {isVisible: false});

  const popupProp = {
    className: classNames(styles.live_penalties_popup, {[styles.small_view]: isSmallView}),
    onClose: () => onClosePopup(),
    shouldRenderBlocker: true
  }

  const livePenaltiesModuleProps = {
    gameId,
    controller,
    competitor: livePenaltiesCompetitorNum,
    athleteIds: livePenaltiesAthletes,
    onClose: () => onClosePopup()
  }

  const externalAdProps = {
    countryId: userCountryId,
    webPage: DBA.PAGE.match,
    isSmallView,
    langId: state.appState.locale.language.id,
    theme: state.appState.theme,
    isMock: state.appState.settings.config.adDisplay === AD_DISPLAYS.placeholders,
    className: classNames(styles.dba_banner),
    controller,
    config: EXTERNAL_AD_CONFIG.MOBILE.MATCH.AD320X100,
  }

  return (
    <>
      <GameCenterWidgetHeader {...baseProps}/>
      {
        isSmallView ? (state.shouldRenderMinuteMediaPlayer ?
          <MinuteMediaAdContainer className={classNames(styles.minute_media_player_banner)}/> : <ExternalAd {...externalAdProps}/>) : null
      }
      <GameCenterWidgetContent {...baseProps}/>
      {
        shouldShowLivePenaltiesPopup ? <Popup {...popupProp}>
          <LivePenaltiesModule {...livePenaltiesModuleProps}/>
        </Popup> : null
      }
    </>
  )
};

const settings: ComposeSettings = {
  component: GameCenterWidget,
  propsType: GameCenterWidgetProps,
  controllerType: GameCenterWidgetController,
  shouldTriggerOnRenderComplete: true,

  createModule: true,
  observe: true,
}

export default Compose(settings);
